import { Colors, Tooltip } from "swing-components";

import { msg } from "~utils";

type TooltipTriggerSubAvailabilityProps = {
  id: string;
};

export function TooltipTriggerSubAvailability(props: TooltipTriggerSubAvailabilityProps) {
  const { id } = props;

  // The `id` prop is used to trigger an Ionic popover by
  // linking this element to the corresponding tooltip.
  return (
    <>
      <button
        id={id}
        css={{
          display: "flex",
          columnGap: 8,
          alignItems: "center",
          background: "none",
          // Allows the tooltip to be clicked,
          // inside the Openings Card
          position: "relative",
          zIndex: 2,
          fontSize: "inherit",
        }}
      >
        <span
          css={{
            fontWeight: 600,
            color: Colors.blue500,
          }}
        >
          {msg("TOOLTIP_AVAILABLE_SOME_DAYS_LABEL")}
        </span>
      </button>
      <Tooltip
        disableIcon
        theme="info"
        trigger={id}
        content={msg("TOOLTIP_AVAILABLE_SOME_DAYS_CONTENT")}
      />
    </>
  );
}
